<template>
  <div v-if="music.music" class="album">
    <span class="iconfont icon-houtui fs-24 fw-700" @click="onClickLeft"></span>
    <span v-if="music.album.status === 99 && music.album.sp_share === 1" class="iconfont icon-share1 fs-24 fw-700 mr-share" @click="share"></span>
    <div class="header">
      <div class="header-bg"  :style="`background: url(${music.album.cover}) center center / cover no-repeat`"></div>
      <div class="header-main">
        <h2 class="fs-22">专辑名称: {{ music.album.album_name }}</h2>
        <p class="fs-12 mt-4">创建时间：<span>{{ music.album.createtime * 1000 | formatTime }}</span></p>
        <div class="flex align-center mt-15">
          <div class="flex align-center album-img mr-20">
            <img :src="music.album.cover" class="img" alt="">
            <img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/h5/bg/bg-album.png" class="bg-img">
          </div>
          <div class="fs-12 author mt-6">
            <p class="main-author van-ellipsis">主表演者：<span class="color-fff">{{ music.album.star }}</span></p>
            <van-tag :color="tagTypes[music.album.status]" class="mt-24" round>{{ musicStatus[music.album.status + String(music.album.sp_online)] }}</van-tag>
          </div>
        </div>
      </div>
    </div>
    <mr-source :source-list="sourceList" :issue-area="music.album.issue_area"></mr-source>
    <div class="main-content">
      <div class="materials-wrapper">
        <div class="flex align-center mb-10 pl-15 pr-15">
          <span class="mr-8">物料完整度</span>
          <van-progress
            :percentage="progressMusic"
            track-color="#F3F4F6"
            :show-pivot="false"
            stroke-width="6px"
            color="linear-gradient(270deg, #0DC268 0%, #4CD964 100%)"
            class="flex-1 mr-8"
          />
          <span>完整度{{ progressMusic }}%</span>
        </div>
        <div class="music">
          <div v-for="(val, idx) in music.music" :key="idx" class="mt-6 music-item">
            <h3 class="flex justify-between align-center">
              <span>
                <span v-show="val.master_song === 1" class="iconfont icon-Solid-1 color-FC3159 fs-16 mr-10"></span>
                {{ idx + 1 }}. {{ val.music_name }}
                <small v-if="val.music_subname">({{ val.music_subname }})</small>
              </span>
              <div class="flex align-center">
                <van-button v-show="val.allow_share === 1" color="#FC3159" round size="mini" class="ml-10 van-btn" @click="share(val)"> <i class="iconfont icon-share1"></i> 分享</van-button>
              </div>
            </h3>
            <div class="flex align-center justify-between mt-15 fs-12">
              <mr-material v-for="item in formatData(val.media_count)" :material="item" :key="item.iconClass" class="fs-12"></mr-material>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mr-share ref="MrShare" :music="music"></mr-share>
  </div>
</template>

<script>
import MrMaterial from '../components/material-item'
import MrSource from '../components/source'
import { getAlbumMusicInfo } from '@/api/music.js'
import { mapState } from 'vuex'
export default {
  name: 'AlbumMusic',
  components: { MrMaterial, MrSource },
  data() {
    return {
      music: {}
    }
  },
  computed: {
    sourceList() {
      const { issue_area } = this.music.album
      return this.areas.map(val => ({
        ...val,
        active: this.issueArea[issue_area].includes(val.key)
      }))
    },
    progressMusic() { // 作品物料百分比
      const totalCount = this.mediaArr.length * this.music.music.length // 物料总个数
      const count = this.music.music.reduce((total, item) => { // 物料点亮的个数
        return total + Object.entries(item.media_count).filter(val => val[1] > 0).length
      }, 0)
      return totalCount === 0 ? 0 : Math.round((100 / totalCount) * count)
    },
    ...mapState(['musicStatus', 'tagTypes', 'mediaArr', 'areas', 'issueArea'])
  },
  async created() {
    try {
      this.$store.commit('TOGGLE_LOADING', true)
      await this.getAlbumMusicInfo()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async getAlbumMusicInfo() {
      const res = await getAlbumMusicInfo({ km_aid: this.$route.query.id })
      this.music = res.data
    },
    formatData(media) { // 格式化物料点亮函数
      const list = Object.entries(media).filter(val => val[1] > 0).map(val => val[0])
      return this.mediaArr.map(val => ({
        ...val,
        active: list.includes(val.key) ? 1 : 0
      }))
    },
    onClickLeft() {
      this.$router.back()
    },
    share(item) {
      this.$refs.MrShare.share({ ...item, album_type: 'album' })
    }
  }
}
</script>

<style lang="scss" scoped>
.album{
  height: 100vh;
}
.icon-houtui,
.mr-share{
  position: absolute;
  top: 10px;
  color: #fff;
  width: 30px;
  height: 30px;
  font-size: 25px;
  z-index: 2;
}
.icon-houtui{
  left: 18px;
}
.mr-share{
  right: 18px;
}
.header{
  position: relative;
  padding-top: 55px;
  padding-bottom: 45px;
  color: #fff;
  .header-bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    &::before{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .5);
    }
  }
  .header-main{
    padding: 0 16px 16px;
    .author{
      line-height: 20px;
      width: 100%;
      .main-author{
        width: 220px;
      }
    }
  }
  .album-img{
    width: 113px;
    height: 108px;
    .img{
      width: 108px;
      height: 108px;
    }
    .bg-img{
      width: 6px;
      height: 100px;
    }
  }
}
.source{
  margin-top: -15px;
}
.main-content{
  margin-top: 10px;
  padding: 15px 0;
  background-color: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  .music-item{
    padding: 10px 16px;
    font-size: 12px;
    &:nth-of-type(2n + 1){
      background-color: #F3F4F6;
    }
  }
}
.mr-fav{
  font-size: 15px;
}
.van-btn{
  display: flex;
  align-items: center;
  width: 65px;
  height: 22px;
  font-size: 14px;
}
</style>
